/**
 * Arabic for the meter register and the Green programme's meter sources.
 * Proposed; pending native review. Point keys, connector names and units are
 * kept as the systems write them.
 */
const ar: Record<string, string> = {
  "Meter register": "سجل العدادات",
  "Every electricity, water, gas and chilled-water meter: what it measures, its last reading and its age, and whether it is live, stale or has never reported; a meter's feed connected, the address a BMS or the on-site gateway posts to, and a BMS export uploaded from a template. The Green programme reads these meters.":
    "كل عدادات الكهرباء والمياه والغاز والمياه المبرّدة: ما يقيسه كل عداد، وآخر قراءة له وعمرها، وهل هو مباشر أو متأخر أو لم يُبلغ قط؛ وربط تغذية العداد، والعنوان الذي يرسل إليه نظام إدارة المبنى أو البوابة الموقعية، ورفع ملف مُصدَّر من نظام إدارة المبنى وفق نموذج. يقرأ البرنامج الأخضر هذه العدادات.",
  "Every electricity, water, gas and chilled-water meter at the site: what it measures, its last reading and how old it is, and whether it is reporting. A BMS posts its readings, the on-site gateway reads Modbus meters and forwards them, or a BMS export is uploaded here — all three through the same connector. The Green program reads these meters.":
    "كل عدادات الكهرباء والمياه والغاز والمياه المبرّدة في الموقع: ما يقيسه كل عداد، وآخر قراءة له وكم مضى عليها، وهل يُبلغ. يرسل نظام إدارة المبنى قراءاته، أو تقرأ البوابة الموقعية عدادات Modbus وتحوّلها، أو يُرفع هنا ملف مُصدَّر من نظام إدارة المبنى — والثلاثة عبر الموصل نفسه. يقرأ البرنامج الأخضر هذه العدادات.",
  "Green & LEED →": "الاستدامة وLEED ←",
  "Meter register →": "سجل العدادات ←",
  "Sample estate: these meters are connected to nothing, which is why the Green program shows its demonstration series. On the platform this lists the airport's own meters and their feeds.":
    "منشأة نموذجية: هذه العدادات غير مربوطة بأي تغذية، ولهذا يعرض البرنامج الأخضر سلسلته التوضيحية. على المنصة تُعرض هنا عدادات المطار نفسه وتغذياتها.",
  "{n} meters: {live} live, {stale} stale, {never} never reported.":
    "{n} عداد: {live} مباشر، {stale} متأخر، {never} لم يُبلغ قط.",
  "{c} of {n} have a feed connected.": "{c} من {n} لها تغذية مربوطة.",
  "Which meters are not reporting?": "أي العدادات لا تُبلغ؟",
  "{live} live · {stale} stale · {never} never reported · {c} of {n} connected":
    "{live} مباشر · {stale} متأخر · {never} لم يُبلغ قط · {c} من {n} مربوط",
  "Connect a meter": "ربط عداد",
  Connect: "ربط",
  "No meters of this kind on the register.": "لا توجد عدادات من هذا النوع في السجل.",
  Measures: "يقيس",
  "Last reading": "آخر قراءة",
  "just now": "الآن",
  "{n} rollovers": "{n} دورة عداد",
  "{n} resets": "{n} إعادة ضبط",
  "amount per interval": "كمية كل فترة",
  register: "قراءة العدّاد التراكمية",
  stale: "متأخر",
  "never reported": "لم يُبلغ قط",
  Utility: "المرفق",
  Gas: "الغاز",
  "Chilled water": "المياه المبرّدة",
  "billed incomer": "عداد التغذية الرئيسي المفوتر",
  "sub-meter": "عداد فرعي",
  "check meter": "عداد تحقق",
  "tenant meter": "عداد مستأجر",
  "on-site generation": "توليد في الموقع",
  "How readings arrive": "كيف تصل القراءات",
  "a BMS that posts, the on-site gateway, or a file": "نظام إدارة مبنى يرسل، أو البوابة الموقعية، أو ملف",
  "A BMS, or the on-site gateway, posts the site's readings to":
    "يرسل نظام إدارة المبنى، أو البوابة الموقعية، قراءات الموقع إلى",
  "with an API key that can write readings and nothing else. Times without an offset are the site's local time. docs/CONNECTING.md, “Meters”, has the whole contract.":
    "بمفتاح API يستطيع كتابة القراءات فقط لا غير. الأوقات التي لا تحمل فرق توقيت تُقرأ بالتوقيت المحلي للموقع. العقد كاملاً في docs/CONNECTING.md، قسم «Meters».",
  "No meter is connected yet. Connect one and the site's meter feed is made, with the address a BMS or the on-site gateway posts to.":
    "لم يُربط أي عداد بعد. اربط عداداً فتُنشأ تغذية عدادات الموقع، مع العنوان الذي يرسل إليه نظام إدارة المبنى أو البوابة الموقعية.",
  "Upload readings": "رفع القراءات",
  "for a BMS that can only export a file": "لنظام إدارة مبنى لا يستطيع إلا تصدير ملف",
  "A CSV with the meter, the time and the value, and optionally whether the value is the register or the amount per interval. Comma, semicolon or tab. The same file uploaded twice changes nothing.":
    "ملف CSV فيه العداد والوقت والقيمة، واختيارياً هل القيمة قراءة تراكمية أم كمية فترة. الفاصل فاصلة أو فاصلة منقوطة أو علامة جدولة. رفع الملف نفسه مرتين لا يغيّر شيئاً.",
  "Readings file": "ملف القراءات",
  "This file was uploaded before; nothing new was written.": "رُفع هذا الملف من قبل؛ لم يُكتب شيء جديد.",
  "{a} accepted · {d} already held · {r} refused, of {n}": "{a} مقبولة · {d} موجودة مسبقاً · {r} مرفوضة، من {n}",
  "line {line}: {reason}": "السطر {line}: {reason}",
  "choose a meter": "اختر عداداً",
  "a meter not yet on the register": "عداد غير موجود في السجل بعد",
  "Point key on the BMS": "اسم النقطة في نظام إدارة المبنى",
  "the meter's tag": "رمز العداد",
  "The number it sends": "الرقم الذي يرسله",
  "the register (a running total)": "القراءة التراكمية (مجموع جارٍ)",
  "the amount used since the last reading": "الكمية المستهلكة منذ آخر قراءة",
  "Register digits": "عدد خانات العدّاد",
  "from the asset": "من بيانات الأصل",
  Multiplier: "المضاعِف",
  "Stale after (minutes)": "يُعدّ متأخراً بعد (دقائق)",

  /* the Green programme, series by series */
  "from the airport's meters": "من عدادات المطار",
  "demonstration series — no meter readings yet": "سلسلة توضيحية — لا توجد قراءات عدادات بعد",
  "no meters on the register": "لا توجد عدادات في السجل",
  "partial: {live} of {total} meters reporting": "جزئي: {live} من {total} عداد تُبلغ",
  "{live} of {total} meters reporting": "{live} من {total} عداد تُبلغ",
  "incomers only, so sub-meters are not counted twice": "العدادات الرئيسية فقط، كي لا تُحسب العدادات الفرعية مرتين",
  "readings from {origins}": "القراءات من {origins}",
};

export default ar;
